'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002ecrud$0024$002dDelete$002dDialog from "./presto.crud$-Delete-Dialog.js";
import * as $j_presto$002etypes$0024proto$0024$002dDelete$002dGroup$002dRequest from "./presto.types$proto$-Delete-Group-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_DeleteGroupView(group) {
  this.aMw = null;
  this.a8i = null;
  this.aMw = group;
  this.a8i = new $j_presto$002ecrud$0024$002dDelete$002dDialog.$c_Lpresto_crud$DeleteDialog("remover grupo");
}
export { $c_Lpresto_DeleteGroupView as $c_Lpresto_DeleteGroupView };
$p = $c_Lpresto_DeleteGroupView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DeleteGroupView;
/** @constructor */
function $h_Lpresto_DeleteGroupView() {
}
export { $h_Lpresto_DeleteGroupView as $h_Lpresto_DeleteGroupView };
$h_Lpresto_DeleteGroupView.prototype = $p;
$p.bU = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_presto$002etypes$0024proto$0024$002dDelete$002dGroup$002dRequest.$c_Lpresto_types$proto$DeleteGroupRequest(this.aMw.fV)));
});
$p.bS = (function() {
  return this.a8i.n3;
});
$p.bF = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(this.a8i.b2());
});
var $d_Lpresto_DeleteGroupView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DeleteGroupView, "presto.DeleteGroupView", ({
  H8: 1,
  J: 1
}));
export { $d_Lpresto_DeleteGroupView as $d_Lpresto_DeleteGroupView };
//# sourceMappingURL=presto.-Delete-Group-View.js.map
